import * as Sentry from '@sentry/vue'
import { Mode } from '@/types/main'

// async function lazyLoadSentryIntegrations() {
//   const router = useRouter()
//   const { browserTracingIntegration } = await import('@sentry/vue')
//
//   // // Плагин для записи ошибки на клиенте
//   // Sentry.addIntegration(
//   //   replayIntegration({
//   //     maskAllText: false,
//   //     blockAllMedia: false,
//   //   }),
//   // )
//
//   // Плагин для трейсинга браузера
//   Sentry.addIntegration(
//     browserTracingIntegration({
//       router,
//     }),
//   )
// }

export default defineNuxtPlugin({
  name: 'initSentry',
  parallel: false,
  setup({ vueApp }) {
    const { SENTRY_DSN, MODE } = useRuntimeConfig().public

    // В зависимости от прода, выставляем нужное значение
    const sampleRate = MODE === Mode.RELEASE ? 0.5 : 0.2

    Sentry.init({
      app: vueApp,
      dsn: SENTRY_DSN,
      enabled: MODE !== Mode.DEVELOPMENT,
      environment: MODE,

      tracesSampleRate: sampleRate,

      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
    })

    // if (process.client) lazyLoadSentryIntegrations()

    return {
      provide: {
        sentryCaptureException: Sentry.captureException,
      },
    }
  },
})
